import React, { useState } from "react";
import { Link } from "react-router-dom";
import image from './images/OGNIFYAR (1).png'
import linkedin from './Icons/linkedin.png'
import facebook from './Icons/facebook (1).png'
import insta from './Icons/instagram (1).png'
import x from './Icons/twitter.png'

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription logic here
    console.log('Subscribed with email:', email);
    setEmail('');
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        {/* Logo and Description */}
        <div className="footer-logo">
          <h1 className="footer-brand">
            <img src={image} alt="Cognifyar Technologies" />
          </h1>
          <div className="social-icons">
            <a href="https://www.linkedin.com/company/cognifyar/?viewAsMember=true" className="icon"><img src={linkedin} alt="LinkedIn" /> </a>
            <a href="#" className="icon"><img src={facebook} alt="Facebook" /> </a>
            <a href="#" className="icon"><img src={insta} alt="Instagram" /> </a>
            <a href="#" className="icon"> <img src={x} alt="Twitter" /></a>
          </div>
        </div>

        {/* Footer Links */}
        <div className="footer-links">
          <div className="footer-column">
            <h3>Company</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to='/about'>About</Link></li>
              <li><Link to='/careers'>Careers</Link></li>
              <li><Link to='/contact'>Contact</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Our Services</h3>
            <ul>
              <li><Link to='/services/servicenow-migration'>ServiceNow Migration</Link></li>
              <li><Link to='/about'>Salesforce Expertise</Link></li>
              <li><Link to='/careers'>Informatica Cloud</Link></li>
              <li><Link to='/contact'>Agentic AI & GenAI</Link></li>
              <li><Link to='/contact'>Power Apps</Link></li>
              <li><Link to='/contact'>Microsoft Copilot</Link></li>
              <li><Link to='/contact'>SAP BTP/HANA</Link></li>
              <li><Link to='/contact'>Data Lake/Delta Lake</Link></li>
              <li><Link to='/contact'>Unqork Automation</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Support</h3>
            <ul>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Cookies Policy</a></li>
              
              <li><a href="#">SMS Policy</a></li>
             
            </ul>
          </div>
          <div className="footer-column newsletter-column">
            <div className="newsletter-section">
              <h3>Newsletter</h3>
              <p>Subscribe to our newsletter for the latest updates</p>
              <form className="newsletter-form" onSubmit={handleSubmit}>
                <input 
                  type="email" 
                  placeholder="Your email address" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit">Subscribe</button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© Cognifyar Technologies. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;